//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ACapReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    startUploadAcapMsrReport(): Promise<string> {
        let url_ = this.baseUrl + "/ACapReport/start-generate-acap-msr-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartUploadAcapMsrReport(_response);
        });
    }

    protected processStartUploadAcapMsrReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startUploadAcapFc1Report(): Promise<string> {
        let url_ = this.baseUrl + "/ACapReport/start-generate-acap-fc1-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartUploadAcapFc1Report(_response);
        });
    }

    protected processStartUploadAcapFc1Report(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startUploadAcapFc3Report(): Promise<string> {
        let url_ = this.baseUrl + "/ACapReport/start-generate-acap-fc3-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartUploadAcapFc3Report(_response);
        });
    }

    protected processStartUploadAcapFc3Report(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startUploadAcapFc35PctReport(): Promise<string> {
        let url_ = this.baseUrl + "/ACapReport/start-generate-acap-fc3-5pct-report";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartUploadAcapFc35PctReport(_response);
        });
    }

    protected processStartUploadAcapFc35PctReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    acapMsrReportTests(): Promise<void> {
        let url_ = this.baseUrl + "/ACapReport/acap-msr-report-tests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcapMsrReportTests(_response);
        });
    }

    protected processAcapMsrReportTests(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    acapReportTests(): Promise<void> {
        let url_ = this.baseUrl + "/ACapReport/acap-report-tests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAcapReportTests(_response);
        });
    }

    protected processAcapReportTests(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CalculateFutureValueClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLatestForecastRunDates(): Promise<ForecastRunDatesResponse> {
        let url_ = this.baseUrl + "/CalculateFutureValue/last-forecast-run-date";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLatestForecastRunDates(_response);
        });
    }

    protected processGetLatestForecastRunDates(response: Response): Promise<ForecastRunDatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForecastRunDatesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForecastRunDatesResponse>(null as any);
    }

    runGenerateFutureValueS3Url(parameters: GenerateFutureValueS3UrlParameters): Promise<TaskRunResponse> {
        let url_ = this.baseUrl + "/CalculateFutureValue/variable-forecast-start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunGenerateFutureValueS3Url(_response);
        });
    }

    protected processRunGenerateFutureValueS3Url(response: Response): Promise<TaskRunResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskRunResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskRunResponse>(null as any);
    }

    getUploadPreSignedUrlAsExcel(taskGuid: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/CalculateFutureValue/variable-forecast-result?";
        if (taskGuid === null)
            throw new globalThis.Error("The parameter 'taskGuid' cannot be null.");
        else if (taskGuid !== undefined)
            url_ += "taskGuid=" + encodeURIComponent("" + taskGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadPreSignedUrlAsExcel(_response);
        });
    }

    protected processGetUploadPreSignedUrlAsExcel(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    runRecalculateFutureValueTask777(parameters: ForecastRecalculateRequest): Promise<TaskRunResponse> {
        let url_ = this.baseUrl + "/CalculateFutureValue/run-overwrite-new-forecasts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(parameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRunRecalculateFutureValueTask777(_response);
        });
    }

    protected processRunRecalculateFutureValueTask777(response: Response): Promise<TaskRunResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskRunResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskRunResponse>(null as any);
    }

    getTaskStatus(guidQuery: string, guidPath: string): Promise<TaskStatusResponse> {
        let url_ = this.baseUrl + "/CalculateFutureValue/status/{guid}?";
        if (guidPath === undefined || guidPath === null)
            throw new globalThis.Error("The parameter 'guidPath' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guidPath));
        if (guidQuery === undefined || guidQuery === null)
            throw new globalThis.Error("The parameter 'guidQuery' must be defined and cannot be null.");
        else
            url_ += "guid=" + encodeURIComponent("" + guidQuery) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTaskStatus(_response);
        });
    }

    protected processGetTaskStatus(response: Response): Promise<TaskStatusResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TaskStatusResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TaskStatusResponse>(null as any);
    }
}

export class CalculatePolicyLapseRatesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getCollateralRollForwardResult(evaluationDate: Date): Promise<FileResponse> {
        let url_ = this.baseUrl + "/CalculatePolicyLapseRates/lapse-rates?";
        if (evaluationDate === undefined || evaluationDate === null)
            throw new globalThis.Error("The parameter 'evaluationDate' must be defined and cannot be null.");
        else
            url_ += "evaluationDate=" + encodeURIComponent(evaluationDate ? "" + evaluationDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCollateralRollForwardResult(_response);
        });
    }

    protected processGetCollateralRollForwardResult(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CommissionsUploadManagerClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUploadManagerSearchResultsByPolicyNumber(policyNumber: string | null): Promise<CommissionUploadManagerSearchResult[]> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/get-by-policy?";
        if (policyNumber === undefined)
            throw new globalThis.Error("The parameter 'policyNumber' must be defined.");
        else if(policyNumber !== null)
            url_ += "policyNumber=" + encodeURIComponent("" + policyNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadManagerSearchResultsByPolicyNumber(_response);
        });
    }

    protected processGetUploadManagerSearchResultsByPolicyNumber(response: Response): Promise<CommissionUploadManagerSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionUploadManagerSearchResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionUploadManagerSearchResult[]>(null as any);
    }

    getUploadManagerSearchResultsBySheetName(sheetName: string | null): Promise<CommissionUploadManagerSearchResult[]> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/get-by-sheet?";
        if (sheetName === undefined)
            throw new globalThis.Error("The parameter 'sheetName' must be defined.");
        else if(sheetName !== null)
            url_ += "sheetName=" + encodeURIComponent("" + sheetName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadManagerSearchResultsBySheetName(_response);
        });
    }

    protected processGetUploadManagerSearchResultsBySheetName(response: Response): Promise<CommissionUploadManagerSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionUploadManagerSearchResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionUploadManagerSearchResult[]>(null as any);
    }

    getUploadManagerSearchResultsBySaleId(saleId: number): Promise<CommissionUploadManagerSearchResult[]> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/get-by-sale-id?";
        if (saleId === undefined || saleId === null)
            throw new globalThis.Error("The parameter 'saleId' must be defined and cannot be null.");
        else
            url_ += "saleId=" + encodeURIComponent("" + saleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadManagerSearchResultsBySaleId(_response);
        });
    }

    protected processGetUploadManagerSearchResultsBySaleId(response: Response): Promise<CommissionUploadManagerSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionUploadManagerSearchResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionUploadManagerSearchResult[]>(null as any);
    }

    getUploadManagerSearchResultsBySmStatus(): Promise<CommissionUploadManagerSearchResult[]> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/get-by-sm-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadManagerSearchResultsBySmStatus(_response);
        });
    }

    protected processGetUploadManagerSearchResultsBySmStatus(response: Response): Promise<CommissionUploadManagerSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionUploadManagerSearchResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionUploadManagerSearchResult[]>(null as any);
    }

    getUploadManagerSearchResultsByUploadInfo(carrierTid: EnsProductCarrierTid, paymentDate: Date | null | undefined, year: number | null | undefined, month: number | null | undefined, productCategoryTid: EnsProductCategory | null | undefined): Promise<CommissionUploadManagerSearchResult[]> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/get-by-upload-info?";
        if (carrierTid === undefined || carrierTid === null)
            throw new globalThis.Error("The parameter 'carrierTid' must be defined and cannot be null.");
        else
            url_ += "carrierTid=" + encodeURIComponent("" + carrierTid) + "&";
        if (paymentDate !== undefined && paymentDate !== null)
            url_ += "paymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toISOString() : "") + "&";
        if (year !== undefined && year !== null)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month !== undefined && month !== null)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (productCategoryTid !== undefined && productCategoryTid !== null)
            url_ += "productCategoryTid=" + encodeURIComponent("" + productCategoryTid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadManagerSearchResultsByUploadInfo(_response);
        });
    }

    protected processGetUploadManagerSearchResultsByUploadInfo(response: Response): Promise<CommissionUploadManagerSearchResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CommissionUploadManagerSearchResult.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionUploadManagerSearchResult[]>(null as any);
    }

    updateEnsSaleCarrierPayment(newRecord: UpdateEnsSaleCarrierPaymentsByTidRequest): Promise<void> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/payment-by-tid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newRecord);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEnsSaleCarrierPayment(_response);
        });
    }

    protected processUpdateEnsSaleCarrierPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateEnsSaleCarrierPaymentsByTid(request: UpdateEnsSaleCarrierPaymentsByTidsRequest): Promise<void> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/payments-by-tid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateEnsSaleCarrierPaymentsByTid(_response);
        });
    }

    protected processUpdateEnsSaleCarrierPaymentsByTid(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteSingleCarrierPayment(ensSaleCarrierPaymentTid: number): Promise<void> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/delete-by-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ensSaleCarrierPaymentTid);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSingleCarrierPayment(_response);
        });
    }

    protected processDeleteSingleCarrierPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    bulkDeleteCarrierPaymentsByDate(carrierTid: EnsProductCarrierTid, productCategoryTid: EnsProductCategory | null | undefined, paymentDate: Date | undefined): Promise<WorkStartResponseOfNullableInteger> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/bulk-delete-by-date?";
        if (carrierTid === undefined || carrierTid === null)
            throw new globalThis.Error("The parameter 'carrierTid' must be defined and cannot be null.");
        else
            url_ += "carrierTid=" + encodeURIComponent("" + carrierTid) + "&";
        if (productCategoryTid !== undefined && productCategoryTid !== null)
            url_ += "productCategoryTid=" + encodeURIComponent("" + productCategoryTid) + "&";
        if (paymentDate === null)
            throw new globalThis.Error("The parameter 'paymentDate' cannot be null.");
        else if (paymentDate !== undefined)
            url_ += "paymentDate=" + encodeURIComponent(paymentDate ? "" + paymentDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkDeleteCarrierPaymentsByDate(_response);
        });
    }

    protected processBulkDeleteCarrierPaymentsByDate(response: Response): Promise<WorkStartResponseOfNullableInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfNullableInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfNullableInteger>(null as any);
    }

    bulkDeleteCarrierPaymentsByMonth(carrierTid: EnsProductCarrierTid, productCategoryTid: EnsProductCategory | null | undefined, year: number, month: number): Promise<WorkStartResponseOfNullableInteger> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/bulk-delete-by-month?";
        if (carrierTid === undefined || carrierTid === null)
            throw new globalThis.Error("The parameter 'carrierTid' must be defined and cannot be null.");
        else
            url_ += "carrierTid=" + encodeURIComponent("" + carrierTid) + "&";
        if (productCategoryTid !== undefined && productCategoryTid !== null)
            url_ += "productCategoryTid=" + encodeURIComponent("" + productCategoryTid) + "&";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === undefined || month === null)
            throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkDeleteCarrierPaymentsByMonth(_response);
        });
    }

    protected processBulkDeleteCarrierPaymentsByMonth(response: Response): Promise<WorkStartResponseOfNullableInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfNullableInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfNullableInteger>(null as any);
    }

    bulkDeleteCarrierPaymentsByTid(carrierPaymentTids: number[]): Promise<WorkStartResponseOfNullableInteger> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/bulk-delete-by-id";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(carrierPaymentTids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkDeleteCarrierPaymentsByTid(_response);
        });
    }

    protected processBulkDeleteCarrierPaymentsByTid(response: Response): Promise<WorkStartResponseOfNullableInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfNullableInteger.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfNullableInteger>(null as any);
    }

    getBulkDeleteByMonthTaskResult(guid: string): Promise<CommissionsBulkDeleteResult> {
        let url_ = this.baseUrl + "/CommissionsUploadManager/bulk-delete-results/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBulkDeleteByMonthTaskResult(_response);
        });
    }

    protected processGetBulkDeleteByMonthTaskResult(response: Response): Promise<CommissionsBulkDeleteResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommissionsBulkDeleteResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommissionsBulkDeleteResult>(null as any);
    }
}

export class DeltaBookingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    startTask(request: DeltaStartReportRequest): Promise<DeltaReportStartResponse> {
        let url_ = this.baseUrl + "/DeltaBooking/start-task";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartTask(_response);
        });
    }

    protected processStartTask(response: Response): Promise<DeltaReportStartResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeltaReportStartResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeltaReportStartResponse>(null as any);
    }
}

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(null as any);
    }
}

export class MonthEndForecastRateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPreviousRates(limit: number): Promise<EnsCommissionForecastMeDzRate[]> {
        let url_ = this.baseUrl + "/MonthEndForecastRate/previous-rates?";
        if (limit === undefined || limit === null)
            throw new globalThis.Error("The parameter 'limit' must be defined and cannot be null.");
        else
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPreviousRates(_response);
        });
    }

    protected processGetPreviousRates(response: Response): Promise<EnsCommissionForecastMeDzRate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EnsCommissionForecastMeDzRate.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsCommissionForecastMeDzRate[]>(null as any);
    }

    addNewRate(newRate: number): Promise<void> {
        let url_ = this.baseUrl + "/MonthEndForecastRate/rate?";
        if (newRate === undefined || newRate === null)
            throw new globalThis.Error("The parameter 'newRate' must be defined and cannot be null.");
        else
            url_ += "newRate=" + encodeURIComponent("" + newRate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddNewRate(_response);
        });
    }

    protected processAddNewRate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class RevenueBookingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    startGenerateReportWork(request: YearMonthBookingReportRequest): Promise<string> {
        let url_ = this.baseUrl + "/RevenueBooking/start-generate-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartGenerateReportWork(_response);
        });
    }

    protected processStartGenerateReportWork(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startGenerateTrueUpReportWork(request: SimpleSaleFilterRequest): Promise<string> {
        let url_ = this.baseUrl + "/RevenueBooking/start-generate-trueup-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartGenerateTrueUpReportWork(_response);
        });
    }

    protected processStartGenerateTrueUpReportWork(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startGenerateLiveReportwork(request: LiveforecastReportRequest): Promise<string> {
        let url_ = this.baseUrl + "/RevenueBooking/start-generate-live-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartGenerateLiveReportwork(_response);
        });
    }

    protected processStartGenerateLiveReportwork(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startGenerateFullCashReceivedReportWork(request: CashRecievedReportFilterRequest): Promise<string> {
        let url_ = this.baseUrl + "/RevenueBooking/start-generate-full-cash-received-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartGenerateFullCashReceivedReportWork(_response);
        });
    }

    protected processStartGenerateFullCashReceivedReportWork(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getForecast1And2InfoByDate(startDate: Date, endDate: Date): Promise<RevenueBookingForecastInfo[]> {
        let url_ = this.baseUrl + "/RevenueBooking/forecast-1-and-2-info?";
        if (startDate === undefined || startDate === null)
            throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForecast1And2InfoByDate(_response);
        });
    }

    protected processGetForecast1And2InfoByDate(response: Response): Promise<RevenueBookingForecastInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueBookingForecastInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevenueBookingForecastInfo[]>(null as any);
    }

    getForecast1And2InfoBySid(saleTids: number[]): Promise<RevenueBookingForecastInfo[]> {
        let url_ = this.baseUrl + "/RevenueBooking/forecast-1-and-2-info-by-sid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(saleTids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetForecast1And2InfoBySid(_response);
        });
    }

    protected processGetForecast1And2InfoBySid(response: Response): Promise<RevenueBookingForecastInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RevenueBookingForecastInfo.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RevenueBookingForecastInfo[]>(null as any);
    }

    checkRevenueExists(month: number, year: number, revenueType: RevenueType): Promise<boolean> {
        let url_ = this.baseUrl + "/RevenueBooking/check-existing?";
        if (month === undefined || month === null)
            throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
        else
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === undefined || year === null)
            throw new globalThis.Error("The parameter 'year' must be defined and cannot be null.");
        else
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (revenueType === undefined || revenueType === null)
            throw new globalThis.Error("The parameter 'revenueType' must be defined and cannot be null.");
        else
            url_ += "revenueType=" + encodeURIComponent("" + revenueType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckRevenueExists(_response);
        });
    }

    protected processCheckRevenueExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    startBookingOriginalRevenueTask(input: RevenueBookingInput): Promise<WorkStartResponseOfBookingStartResponse> {
        let url_ = this.baseUrl + "/RevenueBooking/start-book-original-revenue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartBookingOriginalRevenueTask(_response);
        });
    }

    protected processStartBookingOriginalRevenueTask(response: Response): Promise<WorkStartResponseOfBookingStartResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfBookingStartResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfBookingStartResponse>(null as any);
    }

    startBookingDownstreamRevenueTask(input: RevenueBookingInput): Promise<WorkStartResponseOfBookingStartResponse> {
        let url_ = this.baseUrl + "/RevenueBooking/start-book-downstream-revenue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartBookingDownstreamRevenueTask(_response);
        });
    }

    protected processStartBookingDownstreamRevenueTask(response: Response): Promise<WorkStartResponseOfBookingStartResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfBookingStartResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfBookingStartResponse>(null as any);
    }
}

export class SaleFinanceTagClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAllSaleFinanceTags(): Promise<SaleFinanceTagType[]> {
        let url_ = this.baseUrl + "/SaleFinanceTag/tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSaleFinanceTags(_response);
        });
    }

    protected processGetAllSaleFinanceTags(response: Response): Promise<SaleFinanceTagType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SaleFinanceTagType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleFinanceTagType[]>(null as any);
    }

    getSaleFinanceTagsForSale(ensSaleTid: number): Promise<SaleFinanceTagType[]> {
        let url_ = this.baseUrl + "/SaleFinanceTag/tags/{ensSaleTid}";
        if (ensSaleTid === undefined || ensSaleTid === null)
            throw new globalThis.Error("The parameter 'ensSaleTid' must be defined.");
        url_ = url_.replace("{ensSaleTid}", encodeURIComponent("" + ensSaleTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSaleFinanceTagsForSale(_response);
        });
    }

    protected processGetSaleFinanceTagsForSale(response: Response): Promise<SaleFinanceTagType[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SaleFinanceTagType.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleFinanceTagType[]>(null as any);
    }

    updateSaleFinanceTagsForSale(ensSaleTid: number, callingUser: string | undefined, tagTids: number[]): Promise<void> {
        let url_ = this.baseUrl + "/SaleFinanceTag/tags/{ensSaleTid}?";
        if (ensSaleTid === undefined || ensSaleTid === null)
            throw new globalThis.Error("The parameter 'ensSaleTid' must be defined.");
        url_ = url_.replace("{ensSaleTid}", encodeURIComponent("" + ensSaleTid));
        if (callingUser === null)
            throw new globalThis.Error("The parameter 'callingUser' cannot be null.");
        else if (callingUser !== undefined)
            url_ += "callingUser=" + encodeURIComponent("" + callingUser) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tagTids);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSaleFinanceTagsForSale(_response);
        });
    }

    protected processUpdateSaleFinanceTagsForSale(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SaleStatusToolForecastTabClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSaleStatusToolForecastTab(request: GetSaleStatusToolForecastTabRequest): Promise<GetSaleStatusToolForecastTabResponse[]> {
        let url_ = this.baseUrl + "/SaleStatusToolForecastTab";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSaleStatusToolForecastTab(_response);
        });
    }

    protected processGetSaleStatusToolForecastTab(response: Response): Promise<GetSaleStatusToolForecastTabResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetSaleStatusToolForecastTabResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetSaleStatusToolForecastTabResponse[]>(null as any);
    }
}

export class SpreadsheetClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    startWorksheetInformationTask(sheetGuid: string | null, objectPrefix: string | null): Promise<WorkStartResponseOfWorksheetInformationResponse> {
        let url_ = this.baseUrl + "/Spreadsheet/worksheet-information/start-task?";
        if (sheetGuid === undefined)
            throw new globalThis.Error("The parameter 'sheetGuid' must be defined.");
        else if(sheetGuid !== null)
            url_ += "sheetGuid=" + encodeURIComponent("" + sheetGuid) + "&";
        if (objectPrefix === undefined)
            throw new globalThis.Error("The parameter 'objectPrefix' must be defined.");
        else if(objectPrefix !== null)
            url_ += "objectPrefix=" + encodeURIComponent("" + objectPrefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartWorksheetInformationTask(_response);
        });
    }

    protected processStartWorksheetInformationTask(response: Response): Promise<WorkStartResponseOfWorksheetInformationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfWorksheetInformationResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfWorksheetInformationResponse>(null as any);
    }
}

export class UnmatchedCashClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    startGetUnmatchedCashWork(): Promise<WorkStartResponseOfListOfUnmatchedCashRecord> {
        let url_ = this.baseUrl + "/UnmatchedCash/start-unmatched-cash-work";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processStartGetUnmatchedCashWork(_response);
        });
    }

    protected processStartGetUnmatchedCashWork(response: Response): Promise<WorkStartResponseOfListOfUnmatchedCashRecord> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkStartResponseOfListOfUnmatchedCashRecord.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkStartResponseOfListOfUnmatchedCashRecord>(null as any);
    }
}

export class ForecastRunDatesResponse implements IForecastRunDatesResponse {
    tripleSeven!: ForecastRunStatus;
    tripleSeven5Pct!: ForecastRunStatus;
    uhas!: ForecastRunStatus;
    discounted!: ForecastRunStatus;

    constructor(data?: IForecastRunDatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.tripleSeven = new ForecastRunStatus();
            this.tripleSeven5Pct = new ForecastRunStatus();
            this.uhas = new ForecastRunStatus();
            this.discounted = new ForecastRunStatus();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tripleSeven = _data["tripleSeven"] ? ForecastRunStatus.fromJS(_data["tripleSeven"]) : new ForecastRunStatus();
            this.tripleSeven5Pct = _data["tripleSeven5Pct"] ? ForecastRunStatus.fromJS(_data["tripleSeven5Pct"]) : new ForecastRunStatus();
            this.uhas = _data["uhas"] ? ForecastRunStatus.fromJS(_data["uhas"]) : new ForecastRunStatus();
            this.discounted = _data["discounted"] ? ForecastRunStatus.fromJS(_data["discounted"]) : new ForecastRunStatus();
        }
    }

    static fromJS(data: any): ForecastRunDatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastRunDatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tripleSeven"] = this.tripleSeven ? this.tripleSeven.toJSON() : undefined as any;
        data["tripleSeven5Pct"] = this.tripleSeven5Pct ? this.tripleSeven5Pct.toJSON() : undefined as any;
        data["uhas"] = this.uhas ? this.uhas.toJSON() : undefined as any;
        data["discounted"] = this.discounted ? this.discounted.toJSON() : undefined as any;
        return data;
    }
}

export interface IForecastRunDatesResponse {
    tripleSeven: ForecastRunStatus;
    tripleSeven5Pct: ForecastRunStatus;
    uhas: ForecastRunStatus;
    discounted: ForecastRunStatus;
}

export class ForecastRunStatus implements IForecastRunStatus {
    status!: ForecastStatus;
    finishDate!: Date | undefined;

    constructor(data?: IForecastRunStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.finishDate = _data["finishDate"] ? new Date(_data["finishDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ForecastRunStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastRunStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["finishDate"] = this.finishDate ? this.finishDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IForecastRunStatus {
    status: ForecastStatus;
    finishDate: Date | undefined;
}

export enum ForecastStatus {
    NoData = 0,
    InProgress = 1,
    Finished = 2,
}

export class TaskRunResponse implements ITaskRunResponse {
    guid!: string;

    constructor(data?: ITaskRunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): TaskRunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskRunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface ITaskRunResponse {
    guid: string;
}

export class GenerateFutureValueS3UrlParameters implements IGenerateFutureValueS3UrlParameters {
    forecast_type!: string;
    discount_rate!: string;

    constructor(data?: IGenerateFutureValueS3UrlParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.forecast_type = _data["forecast_type"];
            this.discount_rate = _data["discount_rate"];
        }
    }

    static fromJS(data: any): GenerateFutureValueS3UrlParameters {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateFutureValueS3UrlParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecast_type"] = this.forecast_type;
        data["discount_rate"] = this.discount_rate;
        return data;
    }
}

export interface IGenerateFutureValueS3UrlParameters {
    forecast_type: string;
    discount_rate: string;
}

export class ForecastRecalculateRequest implements IForecastRecalculateRequest {
    outputTableName?: string;
    ensSaleTids?: number[];

    constructor(data?: IForecastRecalculateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outputTableName = _data["outputTableName"];
            if (Array.isArray(_data["ensSaleTids"])) {
                this.ensSaleTids = [] as any;
                for (let item of _data["ensSaleTids"])
                    this.ensSaleTids!.push(item);
            }
        }
    }

    static fromJS(data: any): ForecastRecalculateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastRecalculateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputTableName"] = this.outputTableName;
        if (Array.isArray(this.ensSaleTids)) {
            data["ensSaleTids"] = [];
            for (let item of this.ensSaleTids)
                data["ensSaleTids"].push(item);
        }
        return data;
    }
}

export interface IForecastRecalculateRequest {
    outputTableName?: string;
    ensSaleTids?: number[];
}

export class TaskStatusResponse implements ITaskStatusResponse {
    parent_task_guid!: string;
    sub_tasks!: SubTaskStatus[];

    constructor(data?: ITaskStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sub_tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent_task_guid = _data["parent_task_guid"];
            if (Array.isArray(_data["sub_tasks"])) {
                this.sub_tasks = [] as any;
                for (let item of _data["sub_tasks"])
                    this.sub_tasks!.push(SubTaskStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaskStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent_task_guid"] = this.parent_task_guid;
        if (Array.isArray(this.sub_tasks)) {
            data["sub_tasks"] = [];
            for (let item of this.sub_tasks)
                data["sub_tasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaskStatusResponse {
    parent_task_guid: string;
    sub_tasks: SubTaskStatus[];
}

export class SubTaskStatus implements ISubTaskStatus {
    guid!: string;
    state_type_id!: CronTaskStateType;
    error_message?: string | undefined;

    constructor(data?: ISubTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.state_type_id = _data["state_type_id"];
            this.error_message = _data["error_message"];
        }
    }

    static fromJS(data: any): SubTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SubTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["state_type_id"] = this.state_type_id;
        data["error_message"] = this.error_message;
        return data;
    }
}

export interface ISubTaskStatus {
    guid: string;
    state_type_id: CronTaskStateType;
    error_message?: string | undefined;
}

export enum CronTaskStateType {
    Provisioning = 0,
    Running = 1,
    Success = 2,
    Failure = 3,
}

export class CommissionUploadManagerSearchResult implements ICommissionUploadManagerSearchResult {
    ens_sale_carrier_payment_tid!: number;
    ens_sale_tid!: number;
    carrier_name!: string;
    product_name?: string | undefined;
    ledger_category?: number | undefined;
    policy_number!: string;
    policy_effective_date!: Date;
    payment_date?: Date | undefined;
    payment_effective_date?: Date | undefined;
    entered_date!: Date;
    sheet_name?: string | undefined;
    insured_name?: string | undefined;
    payment_amount!: number;
    ens_product_carrier_tid?: number | undefined;
    ens_product_category_tid?: number | undefined;
    agent_name?: string | undefined;
    is_stephen_matthews?: boolean;

    constructor(data?: ICommissionUploadManagerSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_carrier_payment_tid = _data["ens_sale_carrier_payment_tid"];
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.carrier_name = _data["carrier_name"];
            this.product_name = _data["product_name"];
            this.ledger_category = _data["ledger_category"];
            this.policy_number = _data["policy_number"];
            this.policy_effective_date = _data["policy_effective_date"] ? new Date(_data["policy_effective_date"].toString()) : undefined as any;
            this.payment_date = _data["payment_date"] ? new Date(_data["payment_date"].toString()) : undefined as any;
            this.payment_effective_date = _data["payment_effective_date"] ? new Date(_data["payment_effective_date"].toString()) : undefined as any;
            this.entered_date = _data["entered_date"] ? new Date(_data["entered_date"].toString()) : undefined as any;
            this.sheet_name = _data["sheet_name"];
            this.insured_name = _data["insured_name"];
            this.payment_amount = _data["payment_amount"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_category_tid = _data["ens_product_category_tid"];
            this.agent_name = _data["agent_name"];
            this.is_stephen_matthews = _data["is_stephen_matthews"];
        }
    }

    static fromJS(data: any): CommissionUploadManagerSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionUploadManagerSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_carrier_payment_tid"] = this.ens_sale_carrier_payment_tid;
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["carrier_name"] = this.carrier_name;
        data["product_name"] = this.product_name;
        data["ledger_category"] = this.ledger_category;
        data["policy_number"] = this.policy_number;
        data["policy_effective_date"] = this.policy_effective_date ? this.policy_effective_date.toISOString() : undefined as any;
        data["payment_date"] = this.payment_date ? this.payment_date.toISOString() : undefined as any;
        data["payment_effective_date"] = this.payment_effective_date ? this.payment_effective_date.toISOString() : undefined as any;
        data["entered_date"] = this.entered_date ? this.entered_date.toISOString() : undefined as any;
        data["sheet_name"] = this.sheet_name;
        data["insured_name"] = this.insured_name;
        data["payment_amount"] = this.payment_amount;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_category_tid"] = this.ens_product_category_tid;
        data["agent_name"] = this.agent_name;
        data["is_stephen_matthews"] = this.is_stephen_matthews;
        return data;
    }
}

export interface ICommissionUploadManagerSearchResult {
    ens_sale_carrier_payment_tid: number;
    ens_sale_tid: number;
    carrier_name: string;
    product_name?: string | undefined;
    ledger_category?: number | undefined;
    policy_number: string;
    policy_effective_date: Date;
    payment_date?: Date | undefined;
    payment_effective_date?: Date | undefined;
    entered_date: Date;
    sheet_name?: string | undefined;
    insured_name?: string | undefined;
    payment_amount: number;
    ens_product_carrier_tid?: number | undefined;
    ens_product_category_tid?: number | undefined;
    agent_name?: string | undefined;
    is_stephen_matthews?: boolean;
}

export enum EnsProductCarrierTid {
    None = 0,
    GenericNotSpecified = 1,
    Aaa = 2,
    Aetna = 3,
    Ameritas = 4,
    CatholicLife = 5,
    Cigna = 6,
    Humana = 7,
    LibertyBankers = 8,
    MutualOfOmaha = 9,
    NationalHealthInsuranceCompanyNhic = 10,
    Renaissance = 11,
    Sentinel = 12,
    SilverScript = 13,
    Thrivent = 14,
    Ihc = 15,
    Sagicor = 16,
    Securian = 17,
    Hp1 = 18,
    Surebridge = 19,
    AnicoOfNy = 20,
    Anico = 21,
    HarvardPilgrim = 24,
    Gerber = 25,
    Anthem = 26,
    Cdphp = 28,
    Aig = 29,
    UnitedHealthcare = 30,
    WellCare = 31,
    SunFire = 32,
    PanAmerican = 33,
    AgentE = 34,
    PeoplesHealth = 35,
    ChoicePolicy = 36,
    Aarp = 37,
    Accendo = 39,
    ContinentalLife = 40,
    BlueCrossBlueShield = 41,
    Aflac = 42,
    Allina = 43,
    TierOne = 45,
    PhysiciansMutual = 46,
    Unknown = -1,
}

export enum EnsProductCategory {
    None = 0,
    LifeInsurance = 2,
    MedicalPlan = 3,
    MedicareAdvantage = 4,
    MedicarePdp = 5,
    MedSupp = 6,
    Other = 7,
    VisionDentalHearing = 8,
    MedicareMedicaid = 9,
    MedicareCore = 10,
    DownstreamMa = 11,
    DownstreamPdp = 12,
    OptionalSupplementalBenefit = 13,
    Error = -1,
}

export class UpdateEnsSaleCarrierPaymentsByTidRequest implements IUpdateEnsSaleCarrierPaymentsByTidRequest {
    payment_tid!: number;
    update_record!: UpdatedEnsSaleCarrierPaymentRequest;

    constructor(data?: IUpdateEnsSaleCarrierPaymentsByTidRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.update_record = new UpdatedEnsSaleCarrierPaymentRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment_tid = _data["payment_tid"];
            this.update_record = _data["update_record"] ? UpdatedEnsSaleCarrierPaymentRequest.fromJS(_data["update_record"]) : new UpdatedEnsSaleCarrierPaymentRequest();
        }
    }

    static fromJS(data: any): UpdateEnsSaleCarrierPaymentsByTidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnsSaleCarrierPaymentsByTidRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment_tid"] = this.payment_tid;
        data["update_record"] = this.update_record ? this.update_record.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateEnsSaleCarrierPaymentsByTidRequest {
    payment_tid: number;
    update_record: UpdatedEnsSaleCarrierPaymentRequest;
}

export class UpdatedEnsSaleCarrierPaymentRequest implements IUpdatedEnsSaleCarrierPaymentRequest {
    ens_sale_tid?: number | undefined;
    ledger_category?: number | undefined;
    payment_date?: Date | undefined;
    payment_effective_date?: Date | undefined;
    policy_number?: string | undefined;
    policy_effective_date?: Date | undefined;
    payment_amount?: number | undefined;

    constructor(data?: IUpdatedEnsSaleCarrierPaymentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.ledger_category = _data["ledger_category"];
            this.payment_date = _data["payment_date"] ? new Date(_data["payment_date"].toString()) : undefined as any;
            this.payment_effective_date = _data["payment_effective_date"] ? new Date(_data["payment_effective_date"].toString()) : undefined as any;
            this.policy_number = _data["policy_number"];
            this.policy_effective_date = _data["policy_effective_date"] ? new Date(_data["policy_effective_date"].toString()) : undefined as any;
            this.payment_amount = _data["payment_amount"];
        }
    }

    static fromJS(data: any): UpdatedEnsSaleCarrierPaymentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatedEnsSaleCarrierPaymentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["ledger_category"] = this.ledger_category;
        data["payment_date"] = this.payment_date ? this.payment_date.toISOString() : undefined as any;
        data["payment_effective_date"] = this.payment_effective_date ? this.payment_effective_date.toISOString() : undefined as any;
        data["policy_number"] = this.policy_number;
        data["policy_effective_date"] = this.policy_effective_date ? this.policy_effective_date.toISOString() : undefined as any;
        data["payment_amount"] = this.payment_amount;
        return data;
    }
}

export interface IUpdatedEnsSaleCarrierPaymentRequest {
    ens_sale_tid?: number | undefined;
    ledger_category?: number | undefined;
    payment_date?: Date | undefined;
    payment_effective_date?: Date | undefined;
    policy_number?: string | undefined;
    policy_effective_date?: Date | undefined;
    payment_amount?: number | undefined;
}

export class UpdateEnsSaleCarrierPaymentsByTidsRequest implements IUpdateEnsSaleCarrierPaymentsByTidsRequest {
    payment_tids!: number[];
    update_record!: UpdatedEnsSaleCarrierPaymentRequest;

    constructor(data?: IUpdateEnsSaleCarrierPaymentsByTidsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.payment_tids = [];
            this.update_record = new UpdatedEnsSaleCarrierPaymentRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payment_tids"])) {
                this.payment_tids = [] as any;
                for (let item of _data["payment_tids"])
                    this.payment_tids!.push(item);
            }
            this.update_record = _data["update_record"] ? UpdatedEnsSaleCarrierPaymentRequest.fromJS(_data["update_record"]) : new UpdatedEnsSaleCarrierPaymentRequest();
        }
    }

    static fromJS(data: any): UpdateEnsSaleCarrierPaymentsByTidsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEnsSaleCarrierPaymentsByTidsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payment_tids)) {
            data["payment_tids"] = [];
            for (let item of this.payment_tids)
                data["payment_tids"].push(item);
        }
        data["update_record"] = this.update_record ? this.update_record.toJSON() : undefined as any;
        return data;
    }
}

export interface IUpdateEnsSaleCarrierPaymentsByTidsRequest {
    payment_tids: number[];
    update_record: UpdatedEnsSaleCarrierPaymentRequest;
}

export class WorkStartResponseOfNullableInteger implements IWorkStartResponseOfNullableInteger {
    guid!: string;
    __resultType?: number | undefined;

    constructor(data?: IWorkStartResponseOfNullableInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.__resultType = _data["__resultType"];
        }
    }

    static fromJS(data: any): WorkStartResponseOfNullableInteger {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfNullableInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["__resultType"] = this.__resultType;
        return data;
    }
}

export interface IWorkStartResponseOfNullableInteger {
    guid: string;
    __resultType?: number | undefined;
}

export class CommissionsBulkDeleteResult implements ICommissionsBulkDeleteResult {
    isDone!: boolean;
    successful!: boolean;
    message?: string | undefined;
    results?: number | undefined;

    constructor(data?: ICommissionsBulkDeleteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDone = _data["isDone"];
            this.successful = _data["successful"];
            this.message = _data["message"];
            this.results = _data["results"];
        }
    }

    static fromJS(data: any): CommissionsBulkDeleteResult {
        data = typeof data === 'object' ? data : {};
        let result = new CommissionsBulkDeleteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDone"] = this.isDone;
        data["successful"] = this.successful;
        data["message"] = this.message;
        data["results"] = this.results;
        return data;
    }
}

export interface ICommissionsBulkDeleteResult {
    isDone: boolean;
    successful: boolean;
    message?: string | undefined;
    results?: number | undefined;
}

export class DeltaReportStartResponse implements IDeltaReportStartResponse {
    guid?: string | undefined;
    error_message?: string | undefined;

    constructor(data?: IDeltaReportStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.error_message = _data["error_message"];
        }
    }

    static fromJS(data: any): DeltaReportStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeltaReportStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["error_message"] = this.error_message;
        return data;
    }
}

export interface IDeltaReportStartResponse {
    guid?: string | undefined;
    error_message?: string | undefined;
}

export class DeltaStartReportRequest implements IDeltaStartReportRequest {
    lapse_sheet_prefix?: string;
    lapse_sheet_guid?: string;
    lapse_sheet_user_name?: string;

    constructor(data?: IDeltaStartReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lapse_sheet_prefix = _data["lapse_sheet_prefix"];
            this.lapse_sheet_guid = _data["lapse_sheet_guid"];
            this.lapse_sheet_user_name = _data["lapse_sheet_user_name"];
        }
    }

    static fromJS(data: any): DeltaStartReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeltaStartReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lapse_sheet_prefix"] = this.lapse_sheet_prefix;
        data["lapse_sheet_guid"] = this.lapse_sheet_guid;
        data["lapse_sheet_user_name"] = this.lapse_sheet_user_name;
        return data;
    }
}

export interface IDeltaStartReportRequest {
    lapse_sheet_prefix?: string;
    lapse_sheet_guid?: string;
    lapse_sheet_user_name?: string;
}

export class HealthStatus implements IHealthStatus {
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildEnvironment = _data["buildEnvironment"];
            this.database = _data["database"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildEnvironment"] = this.buildEnvironment;
        data["database"] = this.database;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IHealthStatus {
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;
}

export class EnsCommissionForecastMeDzRate implements IEnsCommissionForecastMeDzRate {
    ensCommissionForecastMeDzRateTid?: number;
    sqlCreatedBy?: string | undefined;
    sqlCreatedDatetime?: Date | undefined;
    sqlModifiedBy?: string | undefined;
    sqlModifiedDatetime?: Date | undefined;
    dateAdded?: Date | undefined;
    rate?: number;

    constructor(data?: IEnsCommissionForecastMeDzRate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensCommissionForecastMeDzRateTid = _data["ensCommissionForecastMeDzRateTid"];
            this.sqlCreatedBy = _data["sqlCreatedBy"];
            this.sqlCreatedDatetime = _data["sqlCreatedDatetime"] ? new Date(_data["sqlCreatedDatetime"].toString()) : undefined as any;
            this.sqlModifiedBy = _data["sqlModifiedBy"];
            this.sqlModifiedDatetime = _data["sqlModifiedDatetime"] ? new Date(_data["sqlModifiedDatetime"].toString()) : undefined as any;
            this.dateAdded = _data["dateAdded"] ? new Date(_data["dateAdded"].toString()) : undefined as any;
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): EnsCommissionForecastMeDzRate {
        data = typeof data === 'object' ? data : {};
        let result = new EnsCommissionForecastMeDzRate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensCommissionForecastMeDzRateTid"] = this.ensCommissionForecastMeDzRateTid;
        data["sqlCreatedBy"] = this.sqlCreatedBy;
        data["sqlCreatedDatetime"] = this.sqlCreatedDatetime ? this.sqlCreatedDatetime.toISOString() : undefined as any;
        data["sqlModifiedBy"] = this.sqlModifiedBy;
        data["sqlModifiedDatetime"] = this.sqlModifiedDatetime ? this.sqlModifiedDatetime.toISOString() : undefined as any;
        data["dateAdded"] = this.dateAdded ? this.dateAdded.toISOString() : undefined as any;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IEnsCommissionForecastMeDzRate {
    ensCommissionForecastMeDzRateTid?: number;
    sqlCreatedBy?: string | undefined;
    sqlCreatedDatetime?: Date | undefined;
    sqlModifiedBy?: string | undefined;
    sqlModifiedDatetime?: Date | undefined;
    dateAdded?: Date | undefined;
    rate?: number;
}

export class YearMonthBookingReportRequest implements IYearMonthBookingReportRequest {
    month!: number;
    year!: number;
    forecast_type_tid!: ReportForecastTid;

    constructor(data?: IYearMonthBookingReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.year = _data["year"];
            this.forecast_type_tid = _data["forecast_type_tid"];
        }
    }

    static fromJS(data: any): YearMonthBookingReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new YearMonthBookingReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["year"] = this.year;
        data["forecast_type_tid"] = this.forecast_type_tid;
        return data;
    }
}

export interface IYearMonthBookingReportRequest {
    month: number;
    year: number;
    forecast_type_tid: ReportForecastTid;
}

export enum ReportForecastTid {
    TrueUp = 2,
    Original = 9,
}

export class SimpleSaleFilterRequest implements ISimpleSaleFilterRequest {
    report_type!: BookingReportCsvFormat;
    filters!: BookingReportSaleFilters | undefined;

    constructor(data?: ISimpleSaleFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.report_type = _data["report_type"];
            this.filters = _data["filters"] ? BookingReportSaleFilters.fromJS(_data["filters"]) : undefined as any;
        }
    }

    static fromJS(data: any): SimpleSaleFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleSaleFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["report_type"] = this.report_type;
        data["filters"] = this.filters ? this.filters.toJSON() : undefined as any;
        return data;
    }
}

export interface ISimpleSaleFilterRequest {
    report_type: BookingReportCsvFormat;
    filters: BookingReportSaleFilters | undefined;
}

export enum BookingReportCsvFormat {
    AdminBaseSeparate = 0,
    AdminBaseTogether = 1,
}

export class BookingReportSaleFilters implements IBookingReportSaleFilters {
    sale_ids?: number[] | undefined;
    carriers?: EnsProductCarrierTid[];
    product_categories?: EnsProductCategory[];
    issue_statuses?: EnsSaleStatusTid[];
    current_statuses?: EnsSaleStatusTid[];
    sale_date_start?: Date | undefined;
    sale_date_end?: Date | undefined;
    sale_effective_date_start?: Date | undefined;
    sale_effective_date_end?: Date | undefined;
    sale_month?: number | undefined;
    sale_year?: number | undefined;

    constructor(data?: IBookingReportSaleFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sale_ids"])) {
                this.sale_ids = [] as any;
                for (let item of _data["sale_ids"])
                    this.sale_ids!.push(item);
            }
            if (Array.isArray(_data["carriers"])) {
                this.carriers = [] as any;
                for (let item of _data["carriers"])
                    this.carriers!.push(item);
            }
            if (Array.isArray(_data["product_categories"])) {
                this.product_categories = [] as any;
                for (let item of _data["product_categories"])
                    this.product_categories!.push(item);
            }
            if (Array.isArray(_data["issue_statuses"])) {
                this.issue_statuses = [] as any;
                for (let item of _data["issue_statuses"])
                    this.issue_statuses!.push(item);
            }
            if (Array.isArray(_data["current_statuses"])) {
                this.current_statuses = [] as any;
                for (let item of _data["current_statuses"])
                    this.current_statuses!.push(item);
            }
            this.sale_date_start = _data["sale_date_start"] ? new Date(_data["sale_date_start"].toString()) : undefined as any;
            this.sale_date_end = _data["sale_date_end"] ? new Date(_data["sale_date_end"].toString()) : undefined as any;
            this.sale_effective_date_start = _data["sale_effective_date_start"] ? new Date(_data["sale_effective_date_start"].toString()) : undefined as any;
            this.sale_effective_date_end = _data["sale_effective_date_end"] ? new Date(_data["sale_effective_date_end"].toString()) : undefined as any;
            this.sale_month = _data["sale_month"];
            this.sale_year = _data["sale_year"];
        }
    }

    static fromJS(data: any): BookingReportSaleFilters {
        data = typeof data === 'object' ? data : {};
        let result = new BookingReportSaleFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sale_ids)) {
            data["sale_ids"] = [];
            for (let item of this.sale_ids)
                data["sale_ids"].push(item);
        }
        if (Array.isArray(this.carriers)) {
            data["carriers"] = [];
            for (let item of this.carriers)
                data["carriers"].push(item);
        }
        if (Array.isArray(this.product_categories)) {
            data["product_categories"] = [];
            for (let item of this.product_categories)
                data["product_categories"].push(item);
        }
        if (Array.isArray(this.issue_statuses)) {
            data["issue_statuses"] = [];
            for (let item of this.issue_statuses)
                data["issue_statuses"].push(item);
        }
        if (Array.isArray(this.current_statuses)) {
            data["current_statuses"] = [];
            for (let item of this.current_statuses)
                data["current_statuses"].push(item);
        }
        data["sale_date_start"] = this.sale_date_start ? this.sale_date_start.toISOString() : undefined as any;
        data["sale_date_end"] = this.sale_date_end ? this.sale_date_end.toISOString() : undefined as any;
        data["sale_effective_date_start"] = this.sale_effective_date_start ? this.sale_effective_date_start.toISOString() : undefined as any;
        data["sale_effective_date_end"] = this.sale_effective_date_end ? this.sale_effective_date_end.toISOString() : undefined as any;
        data["sale_month"] = this.sale_month;
        data["sale_year"] = this.sale_year;
        return data;
    }
}

export interface IBookingReportSaleFilters {
    sale_ids?: number[] | undefined;
    carriers?: EnsProductCarrierTid[];
    product_categories?: EnsProductCategory[];
    issue_statuses?: EnsSaleStatusTid[];
    current_statuses?: EnsSaleStatusTid[];
    sale_date_start?: Date | undefined;
    sale_date_end?: Date | undefined;
    sale_effective_date_start?: Date | undefined;
    sale_effective_date_end?: Date | undefined;
    sale_month?: number | undefined;
    sale_year?: number | undefined;
}

export enum EnsSaleStatusTid {
    Cancelled = 1,
    Deleted = 2,
    Duplicate = 3,
    Incomplete = 4,
    Issued = 5,
    Lapsed = 6,
    NTO = 7,
    Pending = 8,
    PendingCms = 9,
    Rejected = 10,
    RapidDisenrollment = 11,
    Terminated = 12,
    Error = -1,
}

export class LiveforecastReportRequest extends SimpleSaleFilterRequest implements ILiveforecastReportRequest {
    forecast_type_tid!: number;
    forecast_table!: ForecastTableType;

    constructor(data?: ILiveforecastReportRequest) {
        super(data);
    }

     init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.forecast_type_tid = _data["forecast_type_tid"];
            this.forecast_table = _data["forecast_table"];
        }
    }

    static  fromJS(data: any): LiveforecastReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LiveforecastReportRequest();
        result.init(data);
        return result;
    }

     toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["forecast_type_tid"] = this.forecast_type_tid;
        data["forecast_table"] = this.forecast_table;
        super.toJSON(data);
        return data;
    }
}

export interface ILiveforecastReportRequest extends ISimpleSaleFilterRequest {
    forecast_type_tid: number;
    forecast_table: ForecastTableType;
}

export enum ForecastTableType {
    Uhas = 0,
    TripleSeven = 1,
    TripleSeven5Pct = 2,
    Discounted = 3,
}

export class CashRecievedReportFilterRequest implements ICashRecievedReportFilterRequest {
    cash_report_filter_options!: CashReportFilterOptionsC;
    simple_sale_filter_request!: SimpleSaleFilterRequest;

    constructor(data?: ICashRecievedReportFilterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cash_report_filter_options = new CashReportFilterOptionsC();
            this.simple_sale_filter_request = new SimpleSaleFilterRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cash_report_filter_options = _data["cash_report_filter_options"] ? CashReportFilterOptionsC.fromJS(_data["cash_report_filter_options"]) : new CashReportFilterOptionsC();
            this.simple_sale_filter_request = _data["simple_sale_filter_request"] ? SimpleSaleFilterRequest.fromJS(_data["simple_sale_filter_request"]) : new SimpleSaleFilterRequest();
        }
    }

    static fromJS(data: any): CashRecievedReportFilterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CashRecievedReportFilterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cash_report_filter_options"] = this.cash_report_filter_options ? this.cash_report_filter_options.toJSON() : undefined as any;
        data["simple_sale_filter_request"] = this.simple_sale_filter_request ? this.simple_sale_filter_request.toJSON() : undefined as any;
        return data;
    }
}

export interface ICashRecievedReportFilterRequest {
    cash_report_filter_options: CashReportFilterOptionsC;
    simple_sale_filter_request: SimpleSaleFilterRequest;
}

export class CashReportFilterOptionsC implements ICashReportFilterOptionsC {
    gl_account_ids?: number[] | undefined;
    pivot_date_type!: PaymentPivotType;
    pivot_date_start?: Date | undefined;
    pivot_date_end?: Date | undefined;

    constructor(data?: ICashReportFilterOptionsC) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["gl_account_ids"])) {
                this.gl_account_ids = [] as any;
                for (let item of _data["gl_account_ids"])
                    this.gl_account_ids!.push(item);
            }
            this.pivot_date_type = _data["pivot_date_type"];
            this.pivot_date_start = _data["pivot_date_start"] ? new Date(_data["pivot_date_start"].toString()) : undefined as any;
            this.pivot_date_end = _data["pivot_date_end"] ? new Date(_data["pivot_date_end"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CashReportFilterOptionsC {
        data = typeof data === 'object' ? data : {};
        let result = new CashReportFilterOptionsC();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.gl_account_ids)) {
            data["gl_account_ids"] = [];
            for (let item of this.gl_account_ids)
                data["gl_account_ids"].push(item);
        }
        data["pivot_date_type"] = this.pivot_date_type;
        data["pivot_date_start"] = this.pivot_date_start ? this.pivot_date_start.toISOString() : undefined as any;
        data["pivot_date_end"] = this.pivot_date_end ? this.pivot_date_end.toISOString() : undefined as any;
        return data;
    }
}

export interface ICashReportFilterOptionsC {
    gl_account_ids?: number[] | undefined;
    pivot_date_type: PaymentPivotType;
    pivot_date_start?: Date | undefined;
    pivot_date_end?: Date | undefined;
}

export enum PaymentPivotType {
    PaymentEffectiveDate = 0,
    PaymentDate = 1,
}

export class RevenueBookingForecastInfo implements IRevenueBookingForecastInfo {
    sale_tid!: number;
    f1_sum!: number;
    f2_sum!: number;

    constructor(data?: IRevenueBookingForecastInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sale_tid = _data["sale_tid"];
            this.f1_sum = _data["f1_sum"];
            this.f2_sum = _data["f2_sum"];
        }
    }

    static fromJS(data: any): RevenueBookingForecastInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueBookingForecastInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sale_tid"] = this.sale_tid;
        data["f1_sum"] = this.f1_sum;
        data["f2_sum"] = this.f2_sum;
        return data;
    }
}

export interface IRevenueBookingForecastInfo {
    sale_tid: number;
    f1_sum: number;
    f2_sum: number;
}

export enum RevenueType {
    Original = 0,
    TrueUp = 1,
}

export class WorkStartResponseOfBookingStartResponse implements IWorkStartResponseOfBookingStartResponse {
    guid!: string;
    __resultType?: BookingStartResponse | undefined;

    constructor(data?: IWorkStartResponseOfBookingStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.__resultType = _data["__resultType"] ? BookingStartResponse.fromJS(_data["__resultType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkStartResponseOfBookingStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfBookingStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["__resultType"] = this.__resultType ? this.__resultType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkStartResponseOfBookingStartResponse {
    guid: string;
    __resultType?: BookingStartResponse | undefined;
}

export class BookingStartResponse implements IBookingStartResponse {
    success!: boolean;
    error?: BookingError | undefined;

    constructor(data?: IBookingStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): BookingStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BookingStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IBookingStartResponse {
    success: boolean;
    error?: BookingError | undefined;
}

export enum BookingError {
    AcquireLockFailed = 0,
}

export class RevenueBookingInput implements IRevenueBookingInput {
    year!: number;
    month!: number;
    posting_date?: Date | undefined;
    accounting_date?: Date | undefined;

    constructor(data?: IRevenueBookingInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            this.posting_date = _data["posting_date"] ? new Date(_data["posting_date"].toString()) : undefined as any;
            this.accounting_date = _data["accounting_date"] ? new Date(_data["accounting_date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RevenueBookingInput {
        data = typeof data === 'object' ? data : {};
        let result = new RevenueBookingInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        data["posting_date"] = this.posting_date ? this.posting_date.toISOString() : undefined as any;
        data["accounting_date"] = this.accounting_date ? this.accounting_date.toISOString() : undefined as any;
        return data;
    }
}

export interface IRevenueBookingInput {
    year: number;
    month: number;
    posting_date?: Date | undefined;
    accounting_date?: Date | undefined;
}

export class SaleFinanceTagType implements ISaleFinanceTagType {
    tid!: number;
    name!: string;

    constructor(data?: ISaleFinanceTagType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tid = _data["tid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SaleFinanceTagType {
        data = typeof data === 'object' ? data : {};
        let result = new SaleFinanceTagType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tid"] = this.tid;
        data["name"] = this.name;
        return data;
    }
}

export interface ISaleFinanceTagType {
    tid: number;
    name: string;
}

export class GetSaleStatusToolForecastTabResponse implements IGetSaleStatusToolForecastTabResponse {
    ens_sale_tid?: number;
    nominal_fc?: number;
    revenue_fc?: number;
    special_fc?: number;
    sale_date?: Date;
    effective_date?: Date | undefined;
    approved_date?: Date | undefined;
    termination_date?: Date | undefined;

    constructor(data?: IGetSaleStatusToolForecastTabResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.nominal_fc = _data["nominal_fc"];
            this.revenue_fc = _data["revenue_fc"];
            this.special_fc = _data["special_fc"];
            this.sale_date = _data["sale_date"] ? new Date(_data["sale_date"].toString()) : undefined as any;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.approved_date = _data["approved_date"] ? new Date(_data["approved_date"].toString()) : undefined as any;
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetSaleStatusToolForecastTabResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleStatusToolForecastTabResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["nominal_fc"] = this.nominal_fc;
        data["revenue_fc"] = this.revenue_fc;
        data["special_fc"] = this.special_fc;
        data["sale_date"] = this.sale_date ? this.sale_date.toISOString() : undefined as any;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["approved_date"] = this.approved_date ? this.approved_date.toISOString() : undefined as any;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetSaleStatusToolForecastTabResponse {
    ens_sale_tid?: number;
    nominal_fc?: number;
    revenue_fc?: number;
    special_fc?: number;
    sale_date?: Date;
    effective_date?: Date | undefined;
    approved_date?: Date | undefined;
    termination_date?: Date | undefined;
}

export class GetSaleStatusToolForecastTabRequest implements IGetSaleStatusToolForecastTabRequest {
    ensSales?: ForecastTabSaleInfo[] | undefined;
    salesPerPage?: number;
    currentPage?: number;

    constructor(data?: IGetSaleStatusToolForecastTabRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ensSales"])) {
                this.ensSales = [] as any;
                for (let item of _data["ensSales"])
                    this.ensSales!.push(ForecastTabSaleInfo.fromJS(item));
            }
            this.salesPerPage = _data["salesPerPage"];
            this.currentPage = _data["currentPage"];
        }
    }

    static fromJS(data: any): GetSaleStatusToolForecastTabRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSaleStatusToolForecastTabRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ensSales)) {
            data["ensSales"] = [];
            for (let item of this.ensSales)
                data["ensSales"].push(item ? item.toJSON() : undefined as any);
        }
        data["salesPerPage"] = this.salesPerPage;
        data["currentPage"] = this.currentPage;
        return data;
    }
}

export interface IGetSaleStatusToolForecastTabRequest {
    ensSales?: ForecastTabSaleInfo[] | undefined;
    salesPerPage?: number;
    currentPage?: number;
}

export class ForecastTabSaleInfo implements IForecastTabSaleInfo {
    ensSaleTid?: number;
    saleDateTime?: Date;
    effectiveDate?: Date | undefined;
    approvalDatetime?: Date | undefined;
    terminationDate?: Date | undefined;

    constructor(data?: IForecastTabSaleInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleTid = _data["ensSaleTid"];
            this.saleDateTime = _data["saleDateTime"] ? new Date(_data["saleDateTime"].toString()) : undefined as any;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.approvalDatetime = _data["approvalDatetime"] ? new Date(_data["approvalDatetime"].toString()) : undefined as any;
            this.terminationDate = _data["terminationDate"] ? new Date(_data["terminationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ForecastTabSaleInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ForecastTabSaleInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleTid"] = this.ensSaleTid;
        data["saleDateTime"] = this.saleDateTime ? this.saleDateTime.toISOString() : undefined as any;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["approvalDatetime"] = this.approvalDatetime ? this.approvalDatetime.toISOString() : undefined as any;
        data["terminationDate"] = this.terminationDate ? this.terminationDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IForecastTabSaleInfo {
    ensSaleTid?: number;
    saleDateTime?: Date;
    effectiveDate?: Date | undefined;
    approvalDatetime?: Date | undefined;
    terminationDate?: Date | undefined;
}

export class WorkStartResponseOfWorksheetInformationResponse implements IWorkStartResponseOfWorksheetInformationResponse {
    guid!: string;
    __resultType?: WorksheetInformationResponse | undefined;

    constructor(data?: IWorkStartResponseOfWorksheetInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.__resultType = _data["__resultType"] ? WorksheetInformationResponse.fromJS(_data["__resultType"]) : undefined as any;
        }
    }

    static fromJS(data: any): WorkStartResponseOfWorksheetInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfWorksheetInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["__resultType"] = this.__resultType ? this.__resultType.toJSON() : undefined as any;
        return data;
    }
}

export interface IWorkStartResponseOfWorksheetInformationResponse {
    guid: string;
    __resultType?: WorksheetInformationResponse | undefined;
}

export class WorksheetInformationResponse implements IWorksheetInformationResponse {
    worksheets!: SpreadsheetWorksheet[];

    constructor(data?: IWorksheetInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.worksheets = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["worksheets"])) {
                this.worksheets = [] as any;
                for (let item of _data["worksheets"])
                    this.worksheets!.push(SpreadsheetWorksheet.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorksheetInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.worksheets)) {
            data["worksheets"] = [];
            for (let item of this.worksheets)
                data["worksheets"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorksheetInformationResponse {
    worksheets: SpreadsheetWorksheet[];
}

export class SpreadsheetWorksheet implements ISpreadsheetWorksheet {
    name!: string;
    row_count!: number;
    columns?: string[] | undefined;

    constructor(data?: ISpreadsheetWorksheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.row_count = _data["row_count"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(item);
            }
        }
    }

    static fromJS(data: any): SpreadsheetWorksheet {
        data = typeof data === 'object' ? data : {};
        let result = new SpreadsheetWorksheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["row_count"] = this.row_count;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item);
        }
        return data;
    }
}

export interface ISpreadsheetWorksheet {
    name: string;
    row_count: number;
    columns?: string[] | undefined;
}

export class WorkStartResponseOfListOfUnmatchedCashRecord implements IWorkStartResponseOfListOfUnmatchedCashRecord {
    guid!: string;
    __resultType?: UnmatchedCashRecord[] | undefined;

    constructor(data?: IWorkStartResponseOfListOfUnmatchedCashRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            if (Array.isArray(_data["__resultType"])) {
                this.__resultType = [] as any;
                for (let item of _data["__resultType"])
                    this.__resultType!.push(UnmatchedCashRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WorkStartResponseOfListOfUnmatchedCashRecord {
        data = typeof data === 'object' ? data : {};
        let result = new WorkStartResponseOfListOfUnmatchedCashRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        if (Array.isArray(this.__resultType)) {
            data["__resultType"] = [];
            for (let item of this.__resultType)
                data["__resultType"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWorkStartResponseOfListOfUnmatchedCashRecord {
    guid: string;
    __resultType?: UnmatchedCashRecord[] | undefined;
}

export class UnmatchedCashRecord implements IUnmatchedCashRecord {
    db!: CommissionUploadManagerSearchResult;
    match_error_ens_sale_tid!: number;
    match_errors!: string[];

    constructor(data?: IUnmatchedCashRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.db = new CommissionUploadManagerSearchResult();
            this.match_errors = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.db = _data["db"] ? CommissionUploadManagerSearchResult.fromJS(_data["db"]) : new CommissionUploadManagerSearchResult();
            this.match_error_ens_sale_tid = _data["match_error_ens_sale_tid"];
            if (Array.isArray(_data["match_errors"])) {
                this.match_errors = [] as any;
                for (let item of _data["match_errors"])
                    this.match_errors!.push(item);
            }
        }
    }

    static fromJS(data: any): UnmatchedCashRecord {
        data = typeof data === 'object' ? data : {};
        let result = new UnmatchedCashRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["db"] = this.db ? this.db.toJSON() : undefined as any;
        data["match_error_ens_sale_tid"] = this.match_error_ens_sale_tid;
        if (Array.isArray(this.match_errors)) {
            data["match_errors"] = [];
            for (let item of this.match_errors)
                data["match_errors"].push(item);
        }
        return data;
    }
}

export interface IUnmatchedCashRecord {
    db: CommissionUploadManagerSearchResult;
    match_error_ens_sale_tid: number;
    match_errors: string[];
}

export abstract class StateGroupExpander implements IStateGroupExpander {

    constructor(data?: IStateGroupExpander) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StateGroupExpander {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'StateGroupExpander' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IStateGroupExpander {
}

export class MaRuleSearchReqeust implements IMaRuleSearchReqeust {
    carrier!: EnsProductCarrierTid;
    state_group!: StateGroup;
    product_group!: ProdctGroup;
    effective_date_start!: Date;
    effective_date_end!: Date;
    underwriting_status!: EnsSaleUnderwritingStatusTid;

    constructor(data?: IMaRuleSearchReqeust) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.carrier = _data["carrier"];
            this.state_group = _data["state_group"];
            this.product_group = _data["product_group"];
            this.effective_date_start = _data["effective_date_start"] ? new Date(_data["effective_date_start"].toString()) : undefined as any;
            this.effective_date_end = _data["effective_date_end"] ? new Date(_data["effective_date_end"].toString()) : undefined as any;
            this.underwriting_status = _data["underwriting_status"];
        }
    }

    static fromJS(data: any): MaRuleSearchReqeust {
        data = typeof data === 'object' ? data : {};
        let result = new MaRuleSearchReqeust();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["carrier"] = this.carrier;
        data["state_group"] = this.state_group;
        data["product_group"] = this.product_group;
        data["effective_date_start"] = this.effective_date_start ? this.effective_date_start.toISOString() : undefined as any;
        data["effective_date_end"] = this.effective_date_end ? this.effective_date_end.toISOString() : undefined as any;
        data["underwriting_status"] = this.underwriting_status;
        return data;
    }
}

export interface IMaRuleSearchReqeust {
    carrier: EnsProductCarrierTid;
    state_group: StateGroup;
    product_group: ProdctGroup;
    effective_date_start: Date;
    effective_date_end: Date;
    underwriting_status: EnsSaleUnderwritingStatusTid;
}

export enum StateGroup {
    CA_NJ = 0,
    CT_DC_PA = 1,
    PR = 2,
    AllOthers = 3,
}

export enum ProdctGroup {
    MaMapdPdp = 0,
}

export enum EnsSaleUnderwritingStatusTid {
    InitialFULL = 1,
    InitialPRO = 2,
    RenewalPRO = 3,
    ReplacePRO = 4,
    GI = 5,
    UW = 6,
    OE = 7,
    RenewalFULL = 10,
    ReplaceFULL = 11,
    NOPAY = 12,
    BLANK = 13,
}

export class MaRuleSeachResult implements IMaRuleSeachResult {
    rule_tids?: number[] | undefined;
    year_one_base_amount?: number | undefined;
    year_two_plus_base_amount?: number | undefined;
    year_one_admin_amount?: number | undefined;
    year_two_plus_admin_amount?: number | undefined;

    constructor(data?: IMaRuleSeachResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rule_tids"])) {
                this.rule_tids = [] as any;
                for (let item of _data["rule_tids"])
                    this.rule_tids!.push(item);
            }
            this.year_one_base_amount = _data["year_one_base_amount"];
            this.year_two_plus_base_amount = _data["year_two_plus_base_amount"];
            this.year_one_admin_amount = _data["year_one_admin_amount"];
            this.year_two_plus_admin_amount = _data["year_two_plus_admin_amount"];
        }
    }

    static fromJS(data: any): MaRuleSeachResult {
        data = typeof data === 'object' ? data : {};
        let result = new MaRuleSeachResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rule_tids)) {
            data["rule_tids"] = [];
            for (let item of this.rule_tids)
                data["rule_tids"].push(item);
        }
        data["year_one_base_amount"] = this.year_one_base_amount;
        data["year_two_plus_base_amount"] = this.year_two_plus_base_amount;
        data["year_one_admin_amount"] = this.year_one_admin_amount;
        data["year_two_plus_admin_amount"] = this.year_two_plus_admin_amount;
        return data;
    }
}

export interface IMaRuleSeachResult {
    rule_tids?: number[] | undefined;
    year_one_base_amount?: number | undefined;
    year_two_plus_base_amount?: number | undefined;
    year_one_admin_amount?: number | undefined;
    year_two_plus_admin_amount?: number | undefined;
}

export class MaRuleSeachUpdateRequest implements IMaRuleSeachUpdateRequest {
    search_request!: MaRuleSearchReqeust;
    rule_tids?: number[];
    year_one_base_amount!: number;
    year_two_plus_base_amount!: number;
    year_one_admin_amount!: number;
    year_two_plus_admin_amount!: number;
    calling_user!: string;

    constructor(data?: IMaRuleSeachUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.search_request = new MaRuleSearchReqeust();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search_request = _data["search_request"] ? MaRuleSearchReqeust.fromJS(_data["search_request"]) : new MaRuleSearchReqeust();
            if (Array.isArray(_data["rule_tids"])) {
                this.rule_tids = [] as any;
                for (let item of _data["rule_tids"])
                    this.rule_tids!.push(item);
            }
            this.year_one_base_amount = _data["year_one_base_amount"];
            this.year_two_plus_base_amount = _data["year_two_plus_base_amount"];
            this.year_one_admin_amount = _data["year_one_admin_amount"];
            this.year_two_plus_admin_amount = _data["year_two_plus_admin_amount"];
            this.calling_user = _data["calling_user"];
        }
    }

    static fromJS(data: any): MaRuleSeachUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MaRuleSeachUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["search_request"] = this.search_request ? this.search_request.toJSON() : undefined as any;
        if (Array.isArray(this.rule_tids)) {
            data["rule_tids"] = [];
            for (let item of this.rule_tids)
                data["rule_tids"].push(item);
        }
        data["year_one_base_amount"] = this.year_one_base_amount;
        data["year_two_plus_base_amount"] = this.year_two_plus_base_amount;
        data["year_one_admin_amount"] = this.year_one_admin_amount;
        data["year_two_plus_admin_amount"] = this.year_two_plus_admin_amount;
        data["calling_user"] = this.calling_user;
        return data;
    }
}

export interface IMaRuleSeachUpdateRequest {
    search_request: MaRuleSearchReqeust;
    rule_tids?: number[];
    year_one_base_amount: number;
    year_two_plus_base_amount: number;
    year_one_admin_amount: number;
    year_two_plus_admin_amount: number;
    calling_user: string;
}

export class RunCalculateFutureValueTaskParameters extends GenerateFutureValueS3UrlParameters implements IRunCalculateFutureValueTaskParameters {
    sale_tids!: number[];
    output_method!: string;
    key!: string;
    discriminator!: string;

    constructor(data?: IRunCalculateFutureValueTaskParameters) {
        super(data);
        if (!data) {
            this.sale_tids = [];
        }
    }

     init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["sale_tids"])) {
                this.sale_tids = [] as any;
                for (let item of _data["sale_tids"])
                    this.sale_tids!.push(item);
            }
            this.output_method = _data["output_method"];
            this.key = _data["key"];
            this.discriminator = _data["discriminator"];
        }
    }

    static  fromJS(data: any): RunCalculateFutureValueTaskParameters {
        data = typeof data === 'object' ? data : {};
        let result = new RunCalculateFutureValueTaskParameters();
        result.init(data);
        return result;
    }

     toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sale_tids)) {
            data["sale_tids"] = [];
            for (let item of this.sale_tids)
                data["sale_tids"].push(item);
        }
        data["output_method"] = this.output_method;
        data["key"] = this.key;
        data["discriminator"] = this.discriminator;
        super.toJSON(data);
        return data;
    }
}

export interface IRunCalculateFutureValueTaskParameters extends IGenerateFutureValueS3UrlParameters {
    sale_tids: number[];
    output_method: string;
    key: string;
    discriminator: string;
}

export class SheetColumns implements ISheetColumns {
    policy_number_header_name!: string;
    policy_effective_date_header_name!: string;
    payment_date_header_name!: string;
    payment_effective_date_header_name!: string;
    payment_amount_header_name!: string;
    insured_name_header_name?: string | undefined;
    ledger_category_header_name?: string | undefined;
    termination_date?: string | undefined;
    agent_name?: string | undefined;

    constructor(data?: ISheetColumns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policy_number_header_name = _data["policy_number_header_name"];
            this.policy_effective_date_header_name = _data["policy_effective_date_header_name"];
            this.payment_date_header_name = _data["payment_date_header_name"];
            this.payment_effective_date_header_name = _data["payment_effective_date_header_name"];
            this.payment_amount_header_name = _data["payment_amount_header_name"];
            this.insured_name_header_name = _data["insured_name_header_name"];
            this.ledger_category_header_name = _data["ledger_category_header_name"];
            this.termination_date = _data["termination_date"];
            this.agent_name = _data["agent_name"];
        }
    }

    static fromJS(data: any): SheetColumns {
        data = typeof data === 'object' ? data : {};
        let result = new SheetColumns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy_number_header_name"] = this.policy_number_header_name;
        data["policy_effective_date_header_name"] = this.policy_effective_date_header_name;
        data["payment_date_header_name"] = this.payment_date_header_name;
        data["payment_effective_date_header_name"] = this.payment_effective_date_header_name;
        data["payment_amount_header_name"] = this.payment_amount_header_name;
        data["insured_name_header_name"] = this.insured_name_header_name;
        data["ledger_category_header_name"] = this.ledger_category_header_name;
        data["termination_date"] = this.termination_date;
        data["agent_name"] = this.agent_name;
        return data;
    }
}

export interface ISheetColumns {
    policy_number_header_name: string;
    policy_effective_date_header_name: string;
    payment_date_header_name: string;
    payment_effective_date_header_name: string;
    payment_amount_header_name: string;
    insured_name_header_name?: string | undefined;
    ledger_category_header_name?: string | undefined;
    termination_date?: string | undefined;
    agent_name?: string | undefined;
}

export class GetBookOfBusinessChangesTaskSpecs implements IGetBookOfBusinessChangesTaskSpecs {
    sheet_download_guid!: string;
    sheet_download_prefix?: string | undefined;
    sheet_table_name!: string;
    ens_product_carrier_tid!: EnsProductCarrierTid;
    report_carrier_product_category?: EnsProductCategory | undefined;
    sheet_columns!: GetBookOfBusinessChangesSheetColumns;

    constructor(data?: IGetBookOfBusinessChangesTaskSpecs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sheet_columns = new GetBookOfBusinessChangesSheetColumns();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheet_download_guid = _data["sheet_download_guid"];
            this.sheet_download_prefix = _data["sheet_download_prefix"];
            this.sheet_table_name = _data["sheet_table_name"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.report_carrier_product_category = _data["report_carrier_product_category"];
            this.sheet_columns = _data["sheet_columns"] ? GetBookOfBusinessChangesSheetColumns.fromJS(_data["sheet_columns"]) : new GetBookOfBusinessChangesSheetColumns();
        }
    }

    static fromJS(data: any): GetBookOfBusinessChangesTaskSpecs {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookOfBusinessChangesTaskSpecs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheet_download_guid"] = this.sheet_download_guid;
        data["sheet_download_prefix"] = this.sheet_download_prefix;
        data["sheet_table_name"] = this.sheet_table_name;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["report_carrier_product_category"] = this.report_carrier_product_category;
        data["sheet_columns"] = this.sheet_columns ? this.sheet_columns.toJSON() : undefined as any;
        return data;
    }
}

export interface IGetBookOfBusinessChangesTaskSpecs {
    sheet_download_guid: string;
    sheet_download_prefix?: string | undefined;
    sheet_table_name: string;
    ens_product_carrier_tid: EnsProductCarrierTid;
    report_carrier_product_category?: EnsProductCategory | undefined;
    sheet_columns: GetBookOfBusinessChangesSheetColumns;
}

export class GetBookOfBusinessChangesSheetColumns implements IGetBookOfBusinessChangesSheetColumns {
    current_status_header_name!: string;
    policy_number_header_name!: string;
    policy_effective_date_header_name!: string;
    termination_date_header_name?: string;
    approval_date!: Date;
    medicare_id_header_name!: string;
    underwriting_status_header_name?: string;
    issue_state_header_name!: string;

    constructor(data?: IGetBookOfBusinessChangesSheetColumns) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.current_status_header_name = _data["current_status_header_name"];
            this.policy_number_header_name = _data["policy_number_header_name"];
            this.policy_effective_date_header_name = _data["policy_effective_date_header_name"];
            this.termination_date_header_name = _data["termination_date_header_name"];
            this.approval_date = _data["approval_date"] ? new Date(_data["approval_date"].toString()) : undefined as any;
            this.medicare_id_header_name = _data["medicare_id_header_name"];
            this.underwriting_status_header_name = _data["underwriting_status_header_name"];
            this.issue_state_header_name = _data["issue_state_header_name"];
        }
    }

    static fromJS(data: any): GetBookOfBusinessChangesSheetColumns {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookOfBusinessChangesSheetColumns();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current_status_header_name"] = this.current_status_header_name;
        data["policy_number_header_name"] = this.policy_number_header_name;
        data["policy_effective_date_header_name"] = this.policy_effective_date_header_name;
        data["termination_date_header_name"] = this.termination_date_header_name;
        data["approval_date"] = this.approval_date ? this.approval_date.toISOString() : undefined as any;
        data["medicare_id_header_name"] = this.medicare_id_header_name;
        data["underwriting_status_header_name"] = this.underwriting_status_header_name;
        data["issue_state_header_name"] = this.issue_state_header_name;
        return data;
    }
}

export interface IGetBookOfBusinessChangesSheetColumns {
    current_status_header_name: string;
    policy_number_header_name: string;
    policy_effective_date_header_name: string;
    termination_date_header_name?: string;
    approval_date: Date;
    medicare_id_header_name: string;
    underwriting_status_header_name?: string;
    issue_state_header_name: string;
}

export class GetBookOfBusinessChangesResult implements IGetBookOfBusinessChangesResult {
    ens_sale_tid!: number;
    hal_policy_number!: string;
    sheet_policy_number!: string;
    effective_date!: Date | undefined;
    current_termination_date_in_hal!: Date | undefined;
    proposed_termination_date_from_sheet!: Date | undefined;
    policy_match_state!: HalMatchState;
    current_underwriting_status!: string | undefined;
    proposed_underwriting_status!: string | undefined;
    current_issue_state!: string | undefined;
    proposed_issue_state!: string | undefined;

    constructor(data?: IGetBookOfBusinessChangesResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.hal_policy_number = _data["hal_policy_number"];
            this.sheet_policy_number = _data["sheet_policy_number"];
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.current_termination_date_in_hal = _data["current_termination_date_in_hal"] ? new Date(_data["current_termination_date_in_hal"].toString()) : undefined as any;
            this.proposed_termination_date_from_sheet = _data["proposed_termination_date_from_sheet"] ? new Date(_data["proposed_termination_date_from_sheet"].toString()) : undefined as any;
            this.policy_match_state = _data["policy_match_state"];
            this.current_underwriting_status = _data["current_underwriting_status"];
            this.proposed_underwriting_status = _data["proposed_underwriting_status"];
            this.current_issue_state = _data["current_issue_state"];
            this.proposed_issue_state = _data["proposed_issue_state"];
        }
    }

    static fromJS(data: any): GetBookOfBusinessChangesResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetBookOfBusinessChangesResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["hal_policy_number"] = this.hal_policy_number;
        data["sheet_policy_number"] = this.sheet_policy_number;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["current_termination_date_in_hal"] = this.current_termination_date_in_hal ? this.current_termination_date_in_hal.toISOString() : undefined as any;
        data["proposed_termination_date_from_sheet"] = this.proposed_termination_date_from_sheet ? this.proposed_termination_date_from_sheet.toISOString() : undefined as any;
        data["policy_match_state"] = this.policy_match_state;
        data["current_underwriting_status"] = this.current_underwriting_status;
        data["proposed_underwriting_status"] = this.proposed_underwriting_status;
        data["current_issue_state"] = this.current_issue_state;
        data["proposed_issue_state"] = this.proposed_issue_state;
        return data;
    }
}

export interface IGetBookOfBusinessChangesResult {
    ens_sale_tid: number;
    hal_policy_number: string;
    sheet_policy_number: string;
    effective_date: Date | undefined;
    current_termination_date_in_hal: Date | undefined;
    proposed_termination_date_from_sheet: Date | undefined;
    policy_match_state: HalMatchState;
    current_underwriting_status: string | undefined;
    proposed_underwriting_status: string | undefined;
    current_issue_state: string | undefined;
    proposed_issue_state: string | undefined;
}

export enum HalMatchState {
    NoMatch = 0,
    EnsSaleFullMatch_PolicyHistoryFullMatch = 1,
    EnsSaleFullMatch_PolicyHistoryTidOnly = 2,
    EnsSaleFullMatch_NoPolicyHistory = 3,
    EnsSaleTidOnly_PolicyHistoryFullMatch = 4,
}

export class UploadBookOfBusinessTaskSpecs implements IUploadBookOfBusinessTaskSpecs {
    sheet_download_guid!: string;
    sheet_download_prefix?: string | undefined;
    sheet_table_name!: string;
    calling_user!: string;
    ens_product_carrier_tid!: EnsProductCarrierTid;
    report_carrier_product_category?: EnsProductCategory | undefined;
    sheet_table_columns!: GetBookOfBusinessChangesSheetColumns;

    constructor(data?: IUploadBookOfBusinessTaskSpecs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.sheet_table_columns = new GetBookOfBusinessChangesSheetColumns();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheet_download_guid = _data["sheet_download_guid"];
            this.sheet_download_prefix = _data["sheet_download_prefix"];
            this.sheet_table_name = _data["sheet_table_name"];
            this.calling_user = _data["calling_user"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.report_carrier_product_category = _data["report_carrier_product_category"];
            this.sheet_table_columns = _data["sheet_table_columns"] ? GetBookOfBusinessChangesSheetColumns.fromJS(_data["sheet_table_columns"]) : new GetBookOfBusinessChangesSheetColumns();
        }
    }

    static fromJS(data: any): UploadBookOfBusinessTaskSpecs {
        data = typeof data === 'object' ? data : {};
        let result = new UploadBookOfBusinessTaskSpecs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheet_download_guid"] = this.sheet_download_guid;
        data["sheet_download_prefix"] = this.sheet_download_prefix;
        data["sheet_table_name"] = this.sheet_table_name;
        data["calling_user"] = this.calling_user;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["report_carrier_product_category"] = this.report_carrier_product_category;
        data["sheet_table_columns"] = this.sheet_table_columns ? this.sheet_table_columns.toJSON() : undefined as any;
        return data;
    }
}

export interface IUploadBookOfBusinessTaskSpecs {
    sheet_download_guid: string;
    sheet_download_prefix?: string | undefined;
    sheet_table_name: string;
    calling_user: string;
    ens_product_carrier_tid: EnsProductCarrierTid;
    report_carrier_product_category?: EnsProductCategory | undefined;
    sheet_table_columns: GetBookOfBusinessChangesSheetColumns;
}

export class UploadCarrierPaymentsTaskSpecs implements IUploadCarrierPaymentsTaskSpecs {
    sheet_download_guid!: string;
    sheet_download_prefix?: string | undefined;
    sheet_table_name!: string;
    calling_user!: string;
    ens_product_carrier_tid!: EnsProductCarrierTid;
    report_carrier_product_category?: EnsProductCategory | undefined;
    update_underwriting_status?: boolean;
    filter_existing_payments?: boolean;
    sheet_table_columns?: SheetColumns | undefined;

    constructor(data?: IUploadCarrierPaymentsTaskSpecs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sheet_download_guid = _data["sheet_download_guid"];
            this.sheet_download_prefix = _data["sheet_download_prefix"];
            this.sheet_table_name = _data["sheet_table_name"];
            this.calling_user = _data["calling_user"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.report_carrier_product_category = _data["report_carrier_product_category"];
            this.update_underwriting_status = _data["update_underwriting_status"];
            this.filter_existing_payments = _data["filter_existing_payments"];
            this.sheet_table_columns = _data["sheet_table_columns"] ? SheetColumns.fromJS(_data["sheet_table_columns"]) : undefined as any;
        }
    }

    static fromJS(data: any): UploadCarrierPaymentsTaskSpecs {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCarrierPaymentsTaskSpecs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sheet_download_guid"] = this.sheet_download_guid;
        data["sheet_download_prefix"] = this.sheet_download_prefix;
        data["sheet_table_name"] = this.sheet_table_name;
        data["calling_user"] = this.calling_user;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["report_carrier_product_category"] = this.report_carrier_product_category;
        data["update_underwriting_status"] = this.update_underwriting_status;
        data["filter_existing_payments"] = this.filter_existing_payments;
        data["sheet_table_columns"] = this.sheet_table_columns ? this.sheet_table_columns.toJSON() : undefined as any;
        return data;
    }
}

export interface IUploadCarrierPaymentsTaskSpecs {
    sheet_download_guid: string;
    sheet_download_prefix?: string | undefined;
    sheet_table_name: string;
    calling_user: string;
    ens_product_carrier_tid: EnsProductCarrierTid;
    report_carrier_product_category?: EnsProductCategory | undefined;
    update_underwriting_status?: boolean;
    filter_existing_payments?: boolean;
    sheet_table_columns?: SheetColumns | undefined;
}

export class UploadCarrierPaymentTaskResponse implements IUploadCarrierPaymentTaskResponse {
    payment_count?: number;
    sales_report?: UploadCarrierPaymentSaleStatusUpdates[] | undefined;
    matching_errors?: CashMatchingError[] | undefined;

    constructor(data?: IUploadCarrierPaymentTaskResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment_count = _data["payment_count"];
            if (Array.isArray(_data["sales_report"])) {
                this.sales_report = [] as any;
                for (let item of _data["sales_report"])
                    this.sales_report!.push(UploadCarrierPaymentSaleStatusUpdates.fromJS(item));
            }
            if (Array.isArray(_data["matching_errors"])) {
                this.matching_errors = [] as any;
                for (let item of _data["matching_errors"])
                    this.matching_errors!.push(CashMatchingError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UploadCarrierPaymentTaskResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCarrierPaymentTaskResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment_count"] = this.payment_count;
        if (Array.isArray(this.sales_report)) {
            data["sales_report"] = [];
            for (let item of this.sales_report)
                data["sales_report"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.matching_errors)) {
            data["matching_errors"] = [];
            for (let item of this.matching_errors)
                data["matching_errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUploadCarrierPaymentTaskResponse {
    payment_count?: number;
    sales_report?: UploadCarrierPaymentSaleStatusUpdates[] | undefined;
    matching_errors?: CashMatchingError[] | undefined;
}

export class UploadCarrierPaymentSaleStatusUpdates implements IUploadCarrierPaymentSaleStatusUpdates {
    ens_sale_tid?: number;
    policy_number?: string;
    new_sale_status_tid?: number | undefined;
    new_sale_status?: string | undefined;
    term_date?: Date;

    constructor(data?: IUploadCarrierPaymentSaleStatusUpdates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.policy_number = _data["policy_number"];
            this.new_sale_status_tid = _data["new_sale_status_tid"];
            this.new_sale_status = _data["new_sale_status"];
            this.term_date = _data["term_date"] ? new Date(_data["term_date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UploadCarrierPaymentSaleStatusUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new UploadCarrierPaymentSaleStatusUpdates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["policy_number"] = this.policy_number;
        data["new_sale_status_tid"] = this.new_sale_status_tid;
        data["new_sale_status"] = this.new_sale_status;
        data["term_date"] = this.term_date ? this.term_date.toISOString() : undefined as any;
        return data;
    }
}

export interface IUploadCarrierPaymentSaleStatusUpdates {
    ens_sale_tid?: number;
    policy_number?: string;
    new_sale_status_tid?: number | undefined;
    new_sale_status?: string | undefined;
    term_date?: Date;
}

export class CashMatchingError implements ICashMatchingError {
    policy_number!: string;
    effective_date!: Date;
    match_error!: string;

    constructor(data?: ICashMatchingError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policy_number = _data["policy_number"];
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.match_error = _data["match_error"];
        }
    }

    static fromJS(data: any): CashMatchingError {
        data = typeof data === 'object' ? data : {};
        let result = new CashMatchingError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy_number"] = this.policy_number;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["match_error"] = this.match_error;
        return data;
    }
}

export interface ICashMatchingError {
    policy_number: string;
    effective_date: Date;
    match_error: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}